import { AppDispatch, RootState } from '../Store';
import { Api } from '../../Api/Api';
import { createTracedAsyncThunk } from '../../../tracing/trace';
import { downloadBlob } from '../../Utility/downloadBlob';

export interface IGrowerEndOfYearSummaryRequest
{
	SelectedGrowerId: string;
	Year: number;
}

// Unlike the Crop Health PDF (downloadGrowerFieldHealthPdf), this endpoint renders synchronously -
// no session id / poll loop needed, just one request that returns the finished PDF.
export const downloadGrowerEndOfYearSummaryPdf = createTracedAsyncThunk<string, IGrowerEndOfYearSummaryRequest, { dispatch: AppDispatch, state: RootState }>(
	'growerendofyearsummary/download',
	async (context, request: IGrowerEndOfYearSummaryRequest, thunkAPI) =>
	{
		try
		{
			const { auth } = thunkAPI.getState();
			const api = new Api('/api/6', auth.userAuthToken, context);

			const { name, data } = await api.getFileAsync(
				`growers/${request.SelectedGrowerId}/end-of-year-summary/pdf?year=${request.Year}`);

			if (!data.size)
			{
				return thunkAPI.rejectWithValue('There was an error downloading the PDF data.');
			}

			downloadBlob(data, name || `EndOfYearSummary-${request.Year}.pdf`);
			return name;
		}
		// Likely a NetError thrown from the Api class
		catch (e)
		{
			return thunkAPI.rejectWithValue(e.message);
		}
	}
);
